
export const addedStayTemplate_customStay:string = [
    '<div addedstay="" class="card camp-card-body shadow" role="button" id="{{ camp.campID }}">',
    '   <div class="card-body p-2 d-flex flex-column gap-2">',
    '       <div class="d-flex position-relative justify-content-between">',
    '           <div class="d-flex flex-column">',
    '               <p class="mb-0 fs-sm text-dark" camp_name="">{{ camp.camp_name }}</p>',
    '           </div>',
    '           <i remove-stay="" stopID="{{ stopID }}" campID="{{ camp.campID }}" class="ai-trash2 text-dark" role="button">',
    '           </i>',
    '       </div>',
    '   </div>',
    '</div>'
    ].join("\n");

export const addedStayTemplate:string = [
'<div addedstay="" class="card camp-card-body shadow" role="button" id="{{ camp.campID }}">',
'   <div class="card-body p-2 d-flex flex-column gap-2">',
'       <div class="d-flex position-relative justify-content-between">',
'           <div class="d-flex flex-column">',
'               <p class="mb-0 fs-sm text-dark" camp_name="">{{ camp.camp_name }}</p>',
'               <div class="d-flex gap-1">',
'                   <p class="text-muted mb-0 fs-xs">{{ camp.city }}, {{ camp.administrative_area_level_1 }}</p>',
'                   <p class="text-muted mb-0 fs-xs">|</p>',
'                   <p class="text-muted mb-0 fs-xs text-nowrap" stayDistSection="">{{ distSection }}</p>',
'               </div>',
'           </div>',
'           <i remove-stay="" stopID="{{ stopID }}" campID="{{ camp.campID }}" class="ai-trash2 text-dark" role="button">',
'           </i>',
'       </div>',
'       <div class="d-flex justify-content-between">',
'           {{{ genieScoreSection }}}',
'           {{{ genieMatchSection }}}',
'       </div>',
'   </div>',
'</div>'
].join("\n");

export const added_genieWish:string = [
'<div class="card p-2" wishId="{{ legIndex }}-{{ stopIndex }}-{{ idx }}">',
'   <div class="d-flex justify-content-between align-items-center">',
'       <ul class="mb-0">',
'           {{{ wishes_list }}}',
'       </ul>',
'       <i role="button" class="ai-trash2" remWishes="" leg="{{ legIndex }}" stop="{{ stopIndex }}" wishesIdx="{{ idx }}"></i>',
'   </div>',
'</div>',
].join("\n");

export const genie_wishes_added_disp:string = [
'<div class="d-flex flex-column d-center position-absolute top-0 end-0">',
'   <i class="ai-circle-check fs-xl"></i>',
'   <p class="font-sm mb-0">Added</p>',
'</div>'
].join("\n");

export const wishes_result_list_item:string = [
'<li class="d-flex justify-content-between">',
'   <span itinerary-text="">{{ itinerary_item }}</span>',
'   <i class="ai-trash2" rem-li="" role="button"></i>',
'</li>'
].join("\n");

export const genie_wishes_result_no_add:string = [
'<div class="card p-3 pt-1" stopWishesWrapper="">',
'   <div class="d-flex justify-content-between align-items-center position-relative">',
'       <div class="d-flex flex-column flex-fill">',
'           <div class="stopTitle mb-2" style="margin-right:40px;">{{ stopTitle }}</div>',
'           <ul class="px-1" stopWishes_list=""></ul>',
'       </div>',
'       <div suggested-stop-feedback="" class="position-absolute top-0 end-0" role="button" data-bs-toggle="tooltip" title="Lock stop to add interests">',
'           <p class="font-sm mb-0 text-center">Add All</p>',
'       </div>',
'</div>'
].join("\n");

export const genie_wishes_result:string = [
'<div class="card p-3 pt-1" stopWishesWrapper="">',
'   <div class="d-flex justify-content-between align-items-center position-relative">',
'       <div class="d-flex flex-column flex-fill">',
'           <div class="stopTitle mb-2"  style="margin-right:40px;">{{ stopTitle }}</div>',
'           <ul class="px-1" stopWishes_list=""></ul>',
'       </div>',
'       <div class="position-absolute top-0 end-0" role="button" addWishes="" stopID="{{ stopID }}">',
'           <p class="font-sm mb-0 text-center">Add All</p>',
'       </div>',
'</div>'
].join("\n");

export const reorderTabStop: string = [
'<div class="d-flex d-center gap-4" leg="{{ legIndex }}" stop="{{ stopIndex }}">',
'   <i class="ai-menu" style="font-size:2.25rem;"></i>',
'   <div class="card flex-fill">',
'       <div class="bg-userStop rounded-top text-white fw-bold px-2">',
'           {{ stopLabel }}',
'       </div>',
'       <div class="card-body p-2">',
'           <div class="stopTitle">',
'               {{ stopTitle }}',
'           </div>',
'       </div>',
'   </div>',
'</div>'
].join("\n");

export const stayTemplate_genieScore:string = [
'<div class="d-flex gap-1">',
'   <i class="ai-wishesStars"></i>',
'   <p class="mb-0">GenieScore</p>',
'   <strong>{{ genie_score }}</strong>',
'</div>',
].join("\n");

export const stayTemplate_genieMatch:string = [
'<div class="d-flex gap-1">',
'   <i class="ai-genieMatch"></i>',
'   <p class="mb-0">GenieMatch</p>',
'   <strong>{{ genieMatch }}</strong> ',
'</div>',
].join("\n");

export const stayTemplate_addStay:string = [
'<div add-stay-to-stop="" stopID="{{ stopID }}" campid="{{ campID }}" class="square-md border-ag-orange text-primary breathingButton"  role="button">',
'   <i class="ai-plus"></i>',
'</div>',
].join("\n");

export const stayTemplate_addStay_noAccess:string = [
'<div tieredFeature="tieredFeature", level="{{addStayMinAccessLevel}}", msg="To add more campgrounds to your trip,", popupTrigger="{{popupAttr}}" class="square-md border-ag-orange text-primary" role="button">',
'   <i class="ai-plus"></i>',
'</div>'
].join("\n");

export const stayTemplate_s2nSection:string = [
'<img id="s2n-logo" class="containImage" style="height:12px;width:80px;" src="/static/images/s2n-logo-svg.svg">'
].join("\n");

export const stayTemplate_sponsored:string = [
    '<div unaddedstay="" class="card camp-card-body shadow" role="button" id="{{ camp.campID }}">',
    '    <div class="d-none" camp_attributes="" s2n="{{ s2n }}" amenities="{{ amenities }}" activities="{{ activities }}" dist="{{ dist }}" genie_score="{{ genie_score }}" genieMatch="{{ genieMatch }}" p_low="{{ p_low }}" p_high="{{ p_high }}" rv_len="{{ rv_len }}"></div>',
    '    <div class="row g-0">',
    '       <img onerror="this.src=`https://images2-fpascwfudrbufxev.z01.azurefd.net/global/campgrounds/stock/ag_photos/AdobeStock_{{ stockImgNum }}.jpg.webp`" style="object-fit:cover;" class="col-12 col-sm-4 rounded-top rounded-top-sm-0 rounded-start-sm stay-img" src="https://images2-fpascwfudrbufxev.z01.azurefd.net/global/campgrounds/{{ camp.campID }}/ag_photos/img_0.jpg.webp"/>',
    '        <div class="col-8 flex-fill">',
    '           <div class="card-body p-2 d-flex flex-column gap-2">',
    '               <div class="sponsored-camp-badge">Sponsored</div>',
    '               <div class="d-flex position-relative justify-content-between">',
    '                   <div class="d-flex flex-column">',
    '                       <p class="mb-0 fs-sm text-dark fw-bold" camp_name="">{{ camp.camp_name }}</p>',
    '                       <div class="d-flex gap-1">',
    '                           <p class="text-muted mb-0 fs-xs">{{ camp.city }}, {{ camp.administrative_area_level_1 }}</p>',
    '                           <p class="text-muted mb-0 fs-xs">|</p>',
    '                           <p class="text-muted mb-0 fs-xs text-nowrap" stayDistSection="">{{ distSection }}</p>',
    '                       </div>',
    '                   </div>',
    '                   {{{ addStaySection }}}',
    '               </div>',
    '               {{{ s2n_section }}}',
    '               <div class="d-flex gap-2 flex-wrap">',
    '                   {{{ genieScoreSection }}}',
    '                   {{{ genieMatchSection }}}',
    '               </div>',
    '       </div>',
    '     </div>',
    '   </div>',
    '</div>'
    ].join("\n");

export const stayTemplate:string = [
'<div unaddedstay="" style="height:fit-content;" class="card camp-card-body shadow" role="button" id="{{ camp.campID }}">',
'   <div class="d-none" camp_attributes="" s2n="{{ s2n }}" amenities="{{ amenities }}" activities="{{ activities }}" dist="{{ dist }}" genie_score="{{ genie_score }}" genieMatch="{{ genieMatch }}" p_low="{{ p_low }}" p_high="{{ p_high }}" rv_len="{{ rv_len }}"></div>',
'   <div class="row g-0">',
'       <div style="object-fit:cover;" class="col-12 col-sm-4 rounded-top rounded-top-sm-0 rounded-start-sm position-relative">',
'           {{{ favoritedSection }}}',
'           <img onerror="this.src=`https://images2-fpascwfudrbufxev.z01.azurefd.net/global/campgrounds/stock/ag_photos/AdobeStock_{{ stockImgNum }}.jpg.webp`" class="h-100 w-100 rounded-top rounded-top-sm-0 rounded-start-sm stay-img" src="https://images2-fpascwfudrbufxev.z01.azurefd.net/global/campgrounds/{{ camp.campID }}/ag_photos/img_0.jpg.webp"/>',
'       </div>',
'        <div class="col-8 flex-fill">',
'           <div class="card-body p-2 d-flex flex-column gap-2">',
'               <div class="d-flex position-relative justify-content-between">',
'                   <div class="d-flex flex-column">',
'                       <p class="mb-0 fs-sm text-dark fw-bold" camp_name="">{{ camp.camp_name }}</p>',
'                       <div class="d-flex gap-1">',
'                           <p class="text-muted mb-0 fs-xs">{{ camp.city }}, {{ camp.administrative_area_level_1 }}</p>',
'                           <p class="text-muted mb-0 fs-xs">|</p>',
'                           <p class="text-muted mb-0 fs-xs text-nowrap" stayDistSection="">{{ distSection }}</p>',
'                       </div>',
'                   </div>',
'                   {{{ addStaySection }}}',
'               </div>',
'               {{{ s2n_section }}}',
'               <div class="d-flex gap-2 flex-wrap">',
'                   {{{ genieScoreSection }}}',
'                   {{{ genieMatchSection }}}',
'               </div>',
'           </div>',
'   </div>',
'   </div>',
'</div>'
].join("\n");